<template>
    <div class="renderPage animate-fade-in reporte-container">
        <!-- Header Section -->
        <v-toolbar color="primary" dark flat class="mb-4 rounded-xl">
            <v-icon class="mr-2" size="24">mdi-format-list-numbered</v-icon>
            <v-toolbar-title class="text-subtitle-1 text-sm-h5 font-weight-black px-0 text-uppercase">
                Reporte Lista Ventas
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon color="white" to="/home" class="glass-btn">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>

        <v-container fluid class="pa-0">
            <v-row>
                <!-- Filters Area -->
                <v-col cols="12" class="mb-2">
                    <v-card class="glass-card rounded-xl pa-4 elevation-2">
                        <v-form ref="form" v-model="valid">
                            <v-row align="center">
                                <!-- Periodo -->
                                <v-col cols="12" sm="6" md="3" class="py-1">
                                    <v-dialog ref="dialog" v-model="dateModal" :return-value.sync="dates" persistent width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="dates" label="Periodo" prepend-inner-icon="mdi-calendar" readonly required
                                                :rules="dateRules" v-bind="attrs" v-on="on" outlined dense rounded hide-details></v-text-field>
                                        </template>
                                        <v-date-picker v-model="dates" range color="primary">
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="dateModal = false">Cancel</v-btn>
                                            <v-btn text color="primary" @click="$refs.dialog.save(dates)">OK</v-btn>
                                        </v-date-picker>
                                    </v-dialog>
                                </v-col>

                                <!-- Sorteo -->
                                <v-col cols="12" sm="6" md="3" class="py-1">
                                    <v-select label="Sorteo" item-text="descripcion" item-value="id" v-model="idSorteo" :items="sorteos"
                                        @change="onSelectedCategory" outlined dense rounded hide-details prepend-inner-icon="mdi-ticket"></v-select>
                                </v-col>

                                <!-- Puesto -->
                                <v-col cols="12" sm="6" md="3" class="py-1">
                                    <v-select label="Puesto" item-text="ciaNombre" item-value="ciaId" v-model="cia" :items="companies"
                                        :disabled="!validCompany" @change="changeCompanies" outlined dense rounded hide-details prepend-inner-icon="mdi-storefront"></v-select>
                                </v-col>

                                <!-- Usuarios -->
                                <v-col cols="12" sm="6" md="3" class="py-1">
                                    <v-select label="Usuarios" item-text="nombre" item-value="cedula" v-model="reporte.cedula"
                                        :items="usuarios" :disabled="!validUsuarios" outlined dense rounded hide-details prepend-inner-icon="mdi-account"></v-select>
                                </v-col>

                                <!-- Action Buttons -->
                                <v-col cols="12" class="py-2 d-flex justify-end flex-wrap">
                                    <v-btn color="primary" class="rounded-pill font-weight-bold mx-1 mb-2" elevation="2" @click="getReport()" :disabled="!valid" height="40">
                                        <v-icon left>mdi-file-document-outline</v-icon>
                                        Generar
                                    </v-btn>
                                    <v-btn color="secondary" class="rounded-pill font-weight-bold mx-1 mb-2" elevation="2" @click="getTiqueteReport()" :disabled="!valid" height="40">
                                        <v-icon left>mdi-share-variant</v-icon>
                                        Compartir
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card>
                </v-col>

                <!-- Summary Dashboard Cards -->
                <v-col cols="12">
                    <v-row ref="element">
                        <v-col cols="12" sm="6" md="3">
                            <v-card class="glass-card rounded-xl pa-4 text-center elevation-2 d-flex flex-column align-center justify-center">
                                <span class="text-caption text-uppercase font-weight-bold grey--text text--darken-1 mb-1">Venta Normal</span>
                                <span class="text-h6 font-weight-black primary--text">{{ ventaNormal }}</span>
                            </v-card>
                        </v-col>

                        <v-col cols="12" sm="6" md="3">
                            <v-card class="glass-card rounded-xl pa-4 text-center elevation-2 d-flex flex-column align-center justify-center">
                                <span class="text-caption text-uppercase font-weight-bold grey--text text--darken-1 mb-1">Venta Reventado</span>
                                <span class="text-h6 font-weight-black info--text">{{ ventaReventado }}</span>
                            </v-card>
                        </v-col>

                        <v-col cols="12" sm="6" md="3">
                            <v-card class="glass-card rounded-xl pa-4 text-center elevation-2 d-flex flex-column align-center justify-center">
                                <span class="text-caption text-uppercase font-weight-bold grey--text text--darken-1 mb-1">Venta Total</span>
                                <span class="text-h5 font-weight-black success--text">{{ ventaTotal }}</span>
                            </v-card>
                        </v-col>

                        <v-col cols="12" sm="6" md="3">
                            <v-card class="glass-card rounded-xl pa-4 text-center elevation-2 d-flex flex-column align-center justify-center border-winner">
                                <span class="text-caption text-uppercase font-weight-bold error--text mb-1">Número Ganador</span>
                                <span class="text-h4 font-weight-black error--text">{{ numGanador !== undefined && numGanador !== null && numGanador !== '' ? numGanador : '-' }}</span>
                            </v-card>
                        </v-col>

                        <!-- Main Big Data Table -->
                        <v-col cols="12" class="mt-2">
                            <v-card class="rounded-xl overflow-hidden glass-card elevation-2">
                                <v-data-table 
                                    :headers="headersX" 
                                    :items="datos" 
                                    class="premium-table matrix-table"
                                    :items-per-page="-1" 
                                    hide-default-footer
                                    mobile-breakpoint="0"
                                >
                                    <!-- Custom Slots for Numero 1 to 5 to highlight Winner -->
                                    <template v-slot:[`item.Numero1`]="{ item }">
                                        <div class="px-2 py-1 rounded" :class="item.Numero1 === numGanador ? 'error white--text font-weight-black elevation-2' : 'font-weight-medium'">
                                            {{ item.Numero1 }}
                                        </div>
                                    </template>
                                    <template v-slot:[`item.Numero2`]="{ item }">
                                        <div class="px-2 py-1 rounded" :class="item.Numero2 === numGanador ? 'error white--text font-weight-black elevation-2' : 'font-weight-medium'">
                                            {{ item.Numero2 }}
                                        </div>
                                    </template>
                                    <template v-slot:[`item.Numero3`]="{ item }">
                                        <div class="px-2 py-1 rounded" :class="item.Numero3 === numGanador ? 'error white--text font-weight-black elevation-2' : 'font-weight-medium'">
                                            {{ item.Numero3 }}
                                        </div>
                                    </template>
                                    <template v-slot:[`item.Numero4`]="{ item }">
                                        <div class="px-2 py-1 rounded" :class="item.Numero4 === numGanador ? 'error white--text font-weight-black elevation-2' : 'font-weight-medium'">
                                            {{ item.Numero4 }}
                                        </div>
                                    </template>
                                    <template v-slot:[`item.Numero5`]="{ item }">
                                        <div class="px-2 py-1 rounded" :class="item.Numero5 === numGanador ? 'error white--text font-weight-black elevation-2' : 'font-weight-medium'">
                                            {{ item.Numero5 }}
                                        </div>
                                    </template>
                                </v-data-table>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>

                <!-- Tiquete Reporte Dialog -->
                <v-dialog persistent transition="dialog-bottom-transition" v-model="dialogReport" max-width="450" content-class="rounded-xl theme-aware-dialog">
                    <v-card class="glass-card rounded-xl overflow-hidden theme-aware-card">
                        <div v-if="showNewData">
                            <TiqueteReporte v-bind:allwedOnly="true" v-bind:tiqueteInfo="tiqueteInfo" @closed="closed" />
                        </div>
                    </v-card>
                </v-dialog>
                
            </v-row>
        </v-container>
    </div>
</template>

<script>
import axios from "axios";
import { mapMutations } from "vuex";
import { mapGetters } from "vuex";
import html2canvas from "html2canvas";
import TiqueteReporte from "./TiqueteReporte.vue";

export default {
    components: {
        TiqueteReporte,
    },
    data() {
        return {
            dialogReport: false,
            showNewData: false,
            valid: false,
            isRed: false,
            validUsuarios: false,
            validCompany: false,
            validDecargar: false,
            dateModal: false,
            dates: [],
            items: [],
            items2: [],
            usuarios: [],
            companies: [],
            sorteos: [],
            datos: [],
            datos2: [],
            bloques: [],
            tablaFormateada: [],
            cia: "",
            htmlReporte: "",
            ventaNormal: 0,
            ventaReventado: 0,
            ventaTotal: 0,
            numGanador: 0,
            modeloReporteVentas: {
                sorteos: [],
                detalles: [],
            },
            tiqueteInfo: {
                datos: [],
            },
            numerosInfo: {
                idUsuario: "",
                idSorteo: "",
                fechaInicio: new Date(),
                fechaFin: new Date(),
            },
            tab2: 0,
            dateRules: [
                (v) => v.length == 2 || "Fecha Inicial y Fecha Final Requeridas",
            ],
            headersX: [
                { text: 'Número', value: 'Numero1' },
                { text: 'Monto', value: 'Monto1' },
                { text: 'Reventado', value: 'Reventado1' },
                { text: 'Número', value: 'Numero2' },
                { text: 'Monto', value: 'Monto2' },
                { text: 'Reventado', value: 'Reventado2' },
                { text: 'Número', value: 'Numero3' },
                { text: 'Monto', value: 'Monto3' },
                { text: 'Reventado', value: 'Reventado3' },
                { text: 'Número', value: 'Numero4' },
                { text: 'Monto', value: 'Monto4' },
                { text: 'Reventado', value: 'Reventado4' },
                { text: 'Número', value: 'Numero5' },
                { text: 'Monto', value: 'Monto5' },
                { text: 'Reventado', value: 'Reventado5' },
            ],
            headers: [
                // {
                //   text: "Nombre",
                //   align: "start",
                //   value: "nombre",
                // },
                {
                    text: "Sorteo",
                    align: "start",
                    value: "sorteo",
                },
                {
                    text: "Total Comisión",
                    align: "start",
                    value: "comision",
                },
                {
                    text: "Total Venta",
                    align: "start",
                    value: "monto",
                },
                { text: "Números Vendidos", value: "actions", width: 50, sortable: false },
            ],
            headers2: [
                {
                    text: "Sorteo",
                    align: "start",
                    value: "sorteo",
                },
                {
                    text: "Usuario",
                    align: "start",
                    value: "nombre",
                },
                {
                    text: "# Tiquete",
                    align: "start",
                    value: "idTiquete",
                },
                {
                    text: "Cliente",
                    align: "start",
                    value: "cliente",
                },
                {
                    text: "Números",
                    align: "start",
                    value: "numeros",
                },
                {
                    text: "Total",
                    align: "start",
                    value: "total",
                },
            ],
            reporte: {
                cedula: "",
                fechaInicio: new Date().toLocaleString("en-US", { timeZone: "America/Costa_Rica" }),
                fechaFin: new Date().toLocaleString("en-US", { timeZone: "America/Costa_Rica" }),
            },
        };
    },

    computed: {
        ...mapGetters(["user", "strCia"]),
    },

    created() {
        this.reporte.cedula = this.user.cedula;
        this.getCompanies();
        this.cia = this.user.ciaPorDefecto;
        this.getUsuariosPorCia();
        this.getSorteos();
    },

    methods: {
        ...mapMutations(["setStrCia"]),

        getReport() {
            this.getReporteVentas();
            //this.getRecibidos();
        },

        share() {
            // iife here
            (async () => {
                if (!("share" in navigator)) {
                    console.log("Sharing not supported");
                    return;
                }
                // `element` is the HTML element you want to share.
                // `backgroundColor` is the desired background color.
                const canvas = await html2canvas(this.$refs.element);

                canvas.toBlob(async (blob) => {
                    // Even if you want to share just one file you need to
                    // send them as an array of files.
                    const files = [new File([blob], "image.png", { type: blob.type })];
                    const shareData = {
                        text: "",
                        title: "",
                        files,
                    };
                    if (navigator.canShare(shareData)) {
                        try {
                            await navigator.share(shareData);
                        } catch (err) {
                            if (err.name !== "AbortError") {
                                console.error(err.name, err.message);
                            }
                        }
                    } else {
                        console.warn("Sharing not supported", shareData);
                    }
                });
            })();
        },

        getTiqueteReport() {
            this.dialogReport = true;
            this.showNewData = true;
        },

        editItem(item) {
            this.snackValue = false;
            this.editedIndex = this.items.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.verNumerosVendidos();
        },

        highlightNumber(value) {
            // Devuelve true si el número es 5, 10 o 15
            return value === 5 || value === 10 || value === 15;
        },

        changeCompanies() {
            this.getUsuariosPorCia();
        },

        getCompanies() {
            let me = this;
            me.setStrCia(this.user.ciaPorDefecto);
            axios
                .get("api/Usuarios/getCiasPorUsuarioV2?usuarioId=" + this.user.id)
                .then(function (response) {
                    me.companies = response.data;
                    if (me.companies.length > 2) {
                        if (me.user.tipo) {
                            me.reporte.cedula = "0";
                            me.cia = "0";
                            me.validCompany = true;
                        } else {
                            me.reporte.cedula = this.user.id;
                            //me.cia = "0";
                            me.validCompany = false;
                        }
                    } else {
                        me.reporte.cedula = this.user.id;
                        me.validCompany = false;
                    }

                    me.cia = this.user.ciaPorDefecto;
                    //me.ciaOld = this.user.ciaPorDefecto;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        verNumerosVendidos() {
            // this.numerosInfo.idSorteo = 1;
            // this.numerosInfo.fechaInicio = this.dates[0].toString();
            // this.numerosInfo.fechaFin = this.dates[1].toString();

            this.numerosInfo.idSorteo = this.editedItem.idSorteo;
            this.numerosInfo.fechaInicio = this.editedItem.fecha;
            this.numerosInfo.fechaFin = this.editedItem.fecha;
            this.numerosInfo.idUsuario = this.reporte.cedula;
            //this.numerosInfo.modeloReporteVentas = this.modeloReporteVentas;
            this.dialogReport = true;
            this.showNewData = true;
        },

        getSorteos() {
            let me = this;
            axios
                .get("api/Tiempos/GetSorteosAllV3?companyId=" + this.cia)
                .then(function (response) {
                    me.sorteos = response.data;
                    me.idSorteo = me.sorteos[0]["id"];
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        getUsuariosPorCia() {
            let me = this;
            axios
                .get(
                    "api/Usuarios/getUsuariosPorCia?companyId=" +
                    this.cia,
                )
                .then(function (response) {
                    me.usuarios = response.data;
                    console.log(me.user.cedula);
                    const myUser = me.usuarios.find(user => user.cedula === me.user.cedula);
                    console.log(myUser.tipo);
                    if (myUser.tipo === true) {
                        me.reporte.cedula = "0";
                        me.validUsuarios = true;
                    } else {
                        me.reporte.cedula = myUser.cedula;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        getReporteVentas() {
            let me = this;
            axios
                .get(
                    "api/Tiempos/GetNumerosVendidosV2?idUsuario=" +
                    this.user.id +
                    "&fechaInicio=" +
                    this.dates[0].toString() +
                    "&fechaFin=" +
                    this.dates[1].toString() +
                    "&companyId=" +
                    this.cia +
                    "&idSorteo=" +
                    this.idSorteo +
                    "&idUsuarioBanca=" +
                    this.reporte.cedula,
                )
                .then(function (response) {
                    const data = response.data;

                    me.datos2 = data;
                    me.tiqueteInfo.datos = me.datos2;

                    me.ventaNormal = data.ventaNormal;
                    me.ventaReventado = data.ventaReventado;
                    me.ventaTotal = data.ventaTotal;
                    me.numGanador = data.numGanador;

                    me.GenerarTiqueteReporteListaVentas();

                    me.datos = data.detalles.map(item => ({
                        Numero1: item[0],
                        Monto1: item[1],
                        Reventado1: item[2],
                        Numero2: item[3],
                        Monto2: item[4],
                        Reventado2: item[5],
                        Numero3: item[6],
                        Monto3: item[7],
                        Reventado3: item[8],
                        Numero4: item[9],
                        Monto4: item[10],
                        Reventado4: item[11],
                        Numero5: item[12],
                        Monto5: item[13],
                        Reventado5: item[14],
                    }))
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        GenerarTiqueteReporteListaVentas() {
            console.log(this.datos2);
            const selected = this.companies.find(c => c.ciaId === this.cia);
            this.datos2.bancaNombre = selected.ciaNombre;
            console.log(selected.ciaNombre);

            //this.datos2.bancaNombre = 
            this.snackValue = false;
            let me = this;
            axios
                .post(
                    "api/Tiempos/GenerarTiqueteReporteListaVentas",
                    this.datos2
                )
                .then(function (response) {
                    me.htmlReporte = response.data;
                    //console.log(me.tiqueteReport.bancaNombre);
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        generarTabla() {
            // Dividir datos en bloques de rangos específicos
            const rangos = [
                { inicio: 1, fin: 19 },
                { inicio: 20, fin: 39 },
                { inicio: 40, fin: 59 },
                { inicio: 60, fin: 79 },
                { inicio: 80, fin: 99 },
            ];

            this.bloques = rangos.map((rango) =>
                this.datos.detalles.filter(
                    (detalle) =>
                        parseInt(detalle.numero) >= rango.inicio &&
                        parseInt(detalle.numero) <= rango.fin
                )
            );

            // Preparar las filas y columnas
            const maxFilas = Math.max(...this.bloques.map((bloque) => bloque.length));

            this.tablaFormateada = Array.from({ length: maxFilas }, (_, filaIndex) => {
                return this.bloques.flatMap((bloque) => {
                    const dato = bloque[filaIndex] || { numero: "", monto: "", montoReventado: "" };
                    return [dato.numero, dato.monto, dato.montoReventado];
                });
            });
        },

        getRecibidos() {
            let me = this;
            axios
                .get(
                    "api/Reportes/getFacturasRecibidas?cia=" +
                    this.strCia +
                    "&fechaInicio=" +
                    this.dates[0].toString() +
                    "&fechaFin=" +
                    this.dates[1].toString()
                )
                .then(function (response) {
                    me.items2 = response.data;
                    me.validDecargar = true;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        closed() {
            this.customerModal = false;
            this.showNewData = false;
            this.dialogReport = false;
        },
    },
};
</script>

<style scoped>
.reporte-container {
    padding-bottom: 60px;
}

/* Glassmorphism Styles */
.glass-card {
    background: rgba(255, 255, 255, 0.7) !important;
    backdrop-filter: blur(12px) !important;
    border: 1px solid rgba(255, 255, 255, 0.3) !important;
}

.theme--dark .glass-card {
    background: rgba(30, 30, 46, 0.8) !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
}

.glass-btn {
    background: rgba(25, 118, 210, 0.1) !important;
}

/* Table Styling */
.premium-table {
    background: transparent !important;
}

.premium-table >>> th {
    background: rgba(0, 0, 0, 0.03) !important;
    font-weight: 800 !important;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-size: 0.7rem !important;
}

.theme--dark .premium-table >>> th {
    background: rgba(255, 255, 255, 0.05) !important;
}

.premium-table >>> tr:hover {
    background: rgba(25, 118, 210, 0.05) !important;
}

/* Specific styling for matrix table */
.matrix-table >>> td {
    padding: 4px 8px !important;
}

/* Special border for Winner KPI */
.border-winner {
    border: 2px solid rgba(255, 82, 82, 0.3) !important;
    background: rgba(255, 82, 82, 0.05) !important;
}
.theme--dark .border-winner {
    border: 2px solid rgba(255, 82, 82, 0.3) !important;
    background: rgba(255, 82, 82, 0.1) !important;
}

/* Animations */
.animate-fade-in {
    animation: fadeIn 0.4s ease-out;
}

@keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}

/* Theme Aware Dialog/Card */
.theme-aware-dialog {
    border-radius: 24px !important;
}
.theme-aware-card {
    background-color: var(--v-background-base, #ffffff) !important;
}
.theme--dark .theme-aware-card {
    background-color: var(--v-background-base, #1e1e2e) !important;
}
</style>